import { render } from "./Tags.vue?vue&type=template&id=4771f7cd"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"

import "./Tags.vue?vue&type=style&index=0&id=4771f7cd&lang=scss"
script.render = render

export default script